module.exports = __webpack_public_path__ + "media/assets/UserUploadIcon-3f2d9778642d075caba2d72926e2ed43.svg";